/* Hanging Lights — landing page behaviour (vanilla, no deps) v2 */
(function () {
  'use strict';
  var root = document.querySelector('.hl-page');
  if (!root) return;
  var isShopify = !!(window.Shopify && window.Shopify.routes) || root.dataset.shopify === 'true';
  var moneyFmt = root.dataset.moneyFormat || '${{amount}}';
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    if (v.slice(-3) === '.00') v = v.slice(0, -3);
    return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.hl-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Mode demo: swap between white and multi-colour images */
  var stage = document.querySelector('.hl-modes__stage');
  if (stage) {
    var label = stage.querySelector('.hl-modes__label');
    var swatches = document.querySelectorAll('.hl-swatch');
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        var alt = s.dataset.mode === 'alt';
        stage.classList.toggle('is-alt', alt);
        var altVid = stage.querySelector('video.hl-modes__alt');
        if (altVid) { if (alt) { altVid.muted = true; var pp = altVid.play(); if (pp && pp.catch) pp.catch(function () {}); } else { altVid.pause(); } }
        if (label) label.textContent = s.dataset.label || s.textContent.trim();
      });
    });
  }

  /* Demo videos: play when visible, pause when not */
  var vids = document.querySelectorAll('.hl-video video');
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { v.muted = true; vio.observe(v); });
  }

  /* Buy box */
  var buy = document.querySelector('.hl-buy');
  if (buy) {
    var form = buy.querySelector('form[data-hl-cart]');
    var variants = [];
    try { var vEl = buy.querySelector('[data-variants]'); variants = JSON.parse(vEl ? vEl.textContent : '[]'); } catch (err) { variants = []; }
    var setInputs = buy.querySelectorAll('input[name="hl_set"]');
    var colourInputs = buy.querySelectorAll('input[name="hl_colour"]');
    var idInput = buy.querySelector('input[name="id"]');
    var priceEl = buy.querySelector('[data-total]');
    var compareEl = buy.querySelector('[data-total-compare]');
    var perEl = buy.querySelector('[data-per]');
    var qtyEl = buy.querySelector('input[name="quantity"]');
    var addBtn = buy.querySelector('[data-add]');
    var msg = buy.querySelector('.hl-form-msg');
    var stickyPrice = document.querySelector('.hl-sticky [data-sticky-price]');
    var stickyName = document.querySelector('.hl-sticky [data-sticky-name]');
    var mainImg = buy.querySelector('.hl-buy__main');
    var thumbs = buy.querySelectorAll('.hl-buy__thumbs button');
    var stockEl = buy.querySelector('.hl-stock');

    function checkedVal(list) { for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i].value; return list.length ? list[0].value : ''; }
    function findVariant(set, colour) {
      for (var i = 0; i < variants.length; i++) if (variants[i].set === set && (!colour || variants[i].colour === colour)) return variants[i];
      return null;
    }
    function refresh() {
      var set = checkedVal(setInputs), colour = checkedVal(colourInputs);
      /* update each pack card for the chosen colour */
      setInputs.forEach(function (inp) {
        var v = findVariant(inp.value, colour); var card = inp.parentNode;
        var per = card.querySelector('.hl-pack__per');
        if (v && per) { per.textContent = v.available ? money(Math.round(v.price / v.units)) + ' per light' : 'Sold out in ' + colour; per.classList.toggle('is-soldout', !v.available); }
        card.classList.toggle('hl-pack--soldout', !(v && v.available));
      });
      var cur = findVariant(set, colour); if (!cur) return;
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value || '1', 10));
      var price = cur.price * qty, compare = (cur.compare || 0) * qty;
      if (idInput) idInput.value = cur.id;
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) { compareEl.textContent = compare > price ? money(compare) : ''; compareEl.style.display = compare > price ? '' : 'none'; }
      if (perEl) perEl.textContent = money(Math.round(price / (cur.units * qty))) + ' per light · ' + (cur.units * qty) + ' lights · ' + colour;
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyName) stickyName.textContent = cur.title;
      if (stockEl) stockEl.style.display = cur.available ? '' : 'none';
      if (addBtn) { addBtn.disabled = !cur.available; addBtn.querySelector('span').textContent = cur.available ? (addBtn.dataset.labelAdd || 'Add to cart') : (addBtn.dataset.labelSoldout || 'Sold out'); }
      if (mainImg && cur.image && buy.dataset.swapImage !== 'false') { mainImg.src = cur.image; thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.src === cur.image); }); }
      document.dispatchEvent(new CustomEvent('hl:variant', { detail: cur }));
    }
    setInputs.forEach(function (p) { p.addEventListener('change', refresh); });
    colourInputs.forEach(function (p) { p.addEventListener('change', refresh); });
    buy.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { var v = parseInt(qtyEl.value || '1', 10) + parseInt(b.dataset.qty, 10); qtyEl.value = Math.max(1, v); refresh(); });
    });
    if (qtyEl) qtyEl.addEventListener('change', refresh);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { thumbs.forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active'); if (mainImg) { mainImg.src = t.dataset.src; mainImg.alt = t.querySelector('img').alt; } });
    });
    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var set = checkedVal(setInputs), colour = checkedVal(colourInputs); var cur = findVariant(set, colour);
        if (!isShopify) { if (msg) msg.textContent = 'Preview mode — on the live Shopify page this adds ' + (cur ? cur.title : 'your set') + ' to your cart.'; return; }
        if (!cur) return;
        var body = { items: [{ id: parseInt(cur.id, 10), quantity: Math.max(1, parseInt(qtyEl.value || '1', 10)) }] };
        addBtn.disabled = true; if (msg) msg.textContent = 'Adding to cart…';
        fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:add', { detail: body }));
            var dest = buy.dataset.afterAdd === 'cart' ? 'cart' : 'checkout';
            if (msg) msg.textContent = dest === 'cart' ? 'Added — taking you to your cart…' : 'Added — taking you to checkout…';
            window.location.href = routeRoot + dest;
          })
          .catch(function (err) {
            addBtn.disabled = false;
            var handle = function (j) { if (msg) msg.textContent = (j && (j.description || j.message)) || 'Could not add to cart. Please try again.'; };
            if (err && err.json) err.json().then(handle).catch(function () { handle(null); }); else handle(null);
          });
      });
    }
    refresh();

    /* Sticky bar visibility */
    var sticky = document.querySelector('.hl-sticky');
    var hero = document.querySelector('.hl-hero');
    if (sticky && hero) {
      var upd = function () {
        var buyRect = buy.getBoundingClientRect();
        var buyVisible = buyRect.top < window.innerHeight * 0.6 && buyRect.bottom > 0;
        var heroRect = hero.getBoundingClientRect();
        sticky.classList.toggle('is-visible', heroRect.bottom < 0 && !buyVisible);
      };
      window.addEventListener('scroll', upd, { passive: true }); upd();
    }
  }

  /* Smooth anchors */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1); var el = document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
})();
